var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFlagSimple = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M4.688 1.3a.937.937 0 0 1 .937.938v15.595a.937.937 0 1 1-1.875 0V2.238a.937.937 0 0 1 .938-.938m2.145.575a.625.625 0 0 1 .88-.57l9.418 4.219a.625.625 0 0 1 .015 1.134l-9.417 4.53a.625.625 0 0 1-.897-.563z"
})));
SvgFlagSimple.displayName = "SvgFlagSimple";
export { SvgFlagSimple as ReactComponent };
export default SvgFlagSimple;